import React, { Component } from 'react'
import { connect } from 'shalala';
import { Link } from 'react-router-dom';
import { Row, Col, Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useStore } from '../../store';
import ReceptoresExcelList from './excel/list/ReceptoresExcelList';
import SearchByDatesAndKeyword from '../../shared/SearchByDatesAndKeyword';
import ReceptoresFileItemActions from './files/list/components/ReceptoresFileItemActions';

class ReceptoresExcel extends Component {

  state = {
    selectedRowKeys: [],
    selectedRows: [],
    busy: false
  }

  componentDidMount() {
    window.setAppTitle('Receptores excel');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnDateChange = (values) => {
    this.props.paginate(values);
  }

  handleOnKeywordChange = (search) => {
    this.props.paginate({ search });
  }

  handleOnRowClick = (data) => {
    this.props.history.replace({
      pathname: `/app/receptores/excel/${data.id}/info`,
      state: {
        data: {...data}
      }
    });
  }

  render() {
    const { selectedRowKeys, selectedRows } = this.state;
    const { from, to } = this.props.pagination;

    return (
      <>
        <Row>
          <Col sm="auto" md="8" className="mb-2">
            { selectedRowKeys.length > 0 && (
              <div className="mr-3 d-inline-flex pb-2">
                <ReceptoresFileItemActions
                  selectedRowKeys={ selectedRowKeys }
                  selectedRows={ selectedRows }
                  alignRight={ false }
                />
              </div>
            )}

            { selectedRowKeys.length === 0 && (
                <SearchByDatesAndKeyword
                  from={ from }
                  to={ to }
                  onDateChange={ this.handleOnDateChange }
                  onKeywordChange={ this.handleOnKeywordChange }
                />
              )}
          </Col>

          <Col sm="auto" md="4" className="text-right pb-2">
            <Button variant="link"
              as={ Link }
              className="text-secondary"
              to="/app/receptores/archivos"
            >
              Archivos { ' ' }
              <FontAwesomeIcon icon={ ['fas', 'chevron-right'] } />
            </Button>
          </Col>
        </Row>

        <ReceptoresExcelList
          onRowClick={ this.handleOnRowClick }
          selectedRowKeys={ selectedRowKeys }
          selectedRows={ selectedRows }
          onRowSelectionChange={ this.handleOnRowSelectionChange }
        />
      </>
    )
  }
}

const mapState = (store) => {
  return store.app.receptores.excel
}

const mapActions = (actions) => {
  return actions.app.receptores.excel;
}

export default connect(useStore, mapState, mapActions)(ReceptoresExcel);